function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { useGlobalContext, useStore, useStoreActions } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { AgreementStudioProposalMode } from "./AgreementStudioProposalMode";
import { DeclarativeModal } from 'seagull';
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
const noBusiness = 'noBusiness';
export default function AgreementStudio(props) {
  const {
    startLoader,
    stopLoader
  } = useGlobalContext();
  const {
    fetchContacts,
    fetchAgreements,
    fetchProposals,
    fetchLegalTerms,
    fetchQboClasses
  } = useStoreActions();
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  useEffect(() => {
    startLoader();
    const requests = [fetchLegalTerms(), fetchContacts(), fetchAgreements(), fetchProposals(), fetchQboClasses()];
    Promise.all(requests).then(() => stopLoader());
  }, []);
  if (!worksAt || !userEmail) {
    throw makeSentryIgnoredError(noBusiness);
  }
  return /*#__PURE__*/React.createElement(DeclarativeModal, {
    isOpen: true,
    content: () => /*#__PURE__*/React.createElement(AgreementStudioProposalMode, _extends({}, props, {
      relationshipDraft: props.relationshipDraft || null,
      worksAt: worksAt,
      userEmail: userEmail,
      onUploadLegalTermsDocument: fetchLegalTerms
    })),
    onClose: () => {}
  });
}